<template>
  <section class="home-welcome fixed-lg">
    <div>
        <picture>
          <source media="(max-width: 639px)" :srcset="glb.cdnUrl + 'images/desktop/home/homepage-new-sm.webp 420w, ' + glb.cdnUrl + 'images/desktop/home/homepage-new-xs.webp 640w'" sizes="100vw" />
          <source media="(min-width: 640px)" :srcset="glb.cdnUrl + 'images/desktop/home/homepage-new.webp'" />
          <img fetchpriority="high" width="420" height="236" :src="glb.cdnUrl + 'images/desktop/home/homepage-new-sm.webp'" alt="Welcome Home Movoto" />
        </picture>
        <div class="info">
        <h1>
          {{ molang('home.weSupportYourHome') }}
        </h1>
        <div class="info-subtitle text-bold text-center">Search, guidance, and financing — all in one place.</div>
        <div id="searchTab">
          <ul class="tab" data-role="tab">
              <li>
                  <button class="btn white small" type="button" :aria-label="molang('home.buyAHome')" :class="{'active': index==0}" @click="toggle(0)">
                    <span class="f6">{{ molang('home.buy') }}</span> <span class="hidden-xs f6">{{ molang('home.aHome') }}</span>
                  </button>
              </li>
              <li>
                  <button class="btn white small" type="button" :aria-label="molang('home.sellHome')" :class="{'active': index==1}" @click="toggle(1)">
                    <span class="f6">{{ molang('home.sell') }}</span> <span class="hidden-xs f6">{{ molang('home.myHome') }}</span>
                  </button>
              </li>
              <li>
                  <button class="btn white small" type="button" :aria-label="molang('home.homeEstimate')" :class="{'active': index==2}" @click="toggle(2)">
                    <span class="f6">{{ molang('home.homeEstimate') }}</span>
                  </button>
              </li>
          </ul>
          <div v-show="index==0" comp="homeBuy" class="content">
              <mvtSearchbox :heroMode="true" size="large" :placeholder="molang('home.BuyText')" v-model="searchInfo"/>
          </div>
          <div v-show="index==1" comp="homeSell" class="content">
              <mvtInputGeo ref="sellAddressInput" input-id="home-welcome-sell-address" class="large" btnclass="btn default" v-model="sellGeoInfo" :placeholder="molang('home.PriceMyHomeText')"/>
          </div>
          <div v-show="index==2" comp="homePriceEst" class="content">
              <mvtInputGeo ref="addressInput" input-id="home-welcome-estimate-address" class="large" btnclass="btn default" v-model="geoInfo" :placeholder="molang('home.PriceMyHomeText')"/>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>
<script src="./home-welcome.js"></script>
<style lang="scss">
  @use "./home-welcome.scss" as *;
</style>
